(function (){
    if (!jQuery("[data-enable-infinite-scroll]").length)
        return;

    let infScrollOptions = {
        path: '[data-section-type="collection-template"] .pagination a.next',
        append: '[data-section-type="collection-template"] .product-block',
        history: false,
        hideNav: '[data-section-type="collection-template"] .pagination',
        status: '[data-section-type="collection-template"] .page-load-status',
        scrollThreshold: 200
    };
    let infScrollContainer = '[data-section-type="collection-template"] .product-list';

    function initInfScroll(container, options, toDestroy) {
        if (toDestroy)
            toDestroy.destroy();

        if (!jQuery('.pagination a.next').length)
            return;
        let infScroll = new InfiniteScroll(container, options);
        infScroll.on('append', () => {
            theme.ProductBlockManager.loadImages(infScrollContainer)
            theme.initAnimateOnScroll();
            jQuery(document).trigger('cc:ajax-collection:infinite-scroll-new-page')
        })

        return infScroll;
    }

    let infScrollInstance = initInfScroll(infScrollContainer, infScrollOptions);
    jQuery(document).on("cc:ajax-collection:loaded", () => initInfScroll(infScrollContainer, infScrollOptions, infScrollInstance));
})();